module.exports = __webpack_public_path__ + "static/media/playground.2a6b26c4.svg";